<div class="toast-booking">
  <p-toast position="top-right" [key]="'save'">
    <ng-template let-message pTemplate="message">
      <div class="flex flex-col" style="flex: 1">
        <div class="flex gap-3">
          <i
            class="font-semibold"
            [ngClass]="[
              message.severity === 'success' ? 'sctr-icon-check-circle' : 'sctr-icon-alert-circle'
            ]"
            style="font-size: 20px"
          ></i>
          <p class="pb-2 text-md font-medium text-black">
            {{ message.detail }}
          </p>
        </div>
        <div class="pl-[20px]">
          <button
            class="px-[12px] py-[4px] hover:rounded-lg hover:border-solid hover:bg-[#EFF8FF]"
            (click)="openDialog()"
          >
            <p class="text-primary-600 text-md font-semibold">
              {{ 'toast_save_car.change' | translate }}
            </p>
          </button>
        </div>
      </div>
    </ng-template>
  </p-toast>
</div>
<div
  *ngIf="!mobileView; else mobileTemp"
  class="relative rounded-lg border border-[#EAECF0] bg-white bg-opacity-5 shadow-sm max-md:!mb-2 max-md:!p-2 md:!mb-3 md:flex md:!p-4"
>
  <div
    class="relative max-md:!h-[148px] max-md:!w-full md:!h-[186px] md:w-1/3 md:min-w-[33.33%] md:max-w-[33.33%]"
  >
    <a
      [routerLink]="[detailLink()]"
      [queryParams]="detailParams(item.id)"
      [replaceUrl]="true"
      target="_self"
    >
      <img
        class="!h-full min-w-full !max-w-full cursor-pointer rounded-lg border !object-cover"
        (click)="viewDetail()"
        [src]="getPropertyImageId(item)"
      />
    </a>
    <ng-container
      *ngIf="
        item.badge_info &&
        item.badge_info.badge_info?.id &&
        item.badge_info.badge_info?.avatar &&
        !isWithDriverServiceType
      "
      [ngTemplateOutlet]="badgeTemplate"
      [ngTemplateOutletContext]="{ $implicit: item.badge_info.badge_info }"
    >
    </ng-container>
    <ng-container
      *ngIf="
        badgeMappingInfo &&
        badgeMappingInfo.badge_info_list &&
        badgeMappingInfo.badge_info_list.length > 0 &&
        isWithDriverServiceType
      "
    >
      <div *ngFor="let badge of badgeMappingInfo.badge_info_list">
        <ng-container
          [ngTemplateOutlet]="badgeTemplate"
          [ngTemplateOutletContext]="{ $implicit: badge }"
        >
        </ng-container>
      </div>
    </ng-container>
    <span
      *ngIf="promotion"
      class="bg-gradient-orange absolute !bottom-2 !left-2 rounded-bl-md rounded-tr-md !px-1 !py-0.5 text-center !text-sm font-semibold text-white"
      >-{{ promotion }}%</span
    >
    <div
      (click)="handleBookmark($event, item.id)"
      class="absolute right-2 top-2 cursor-pointer bg-[#10182866] max-md:!h-7 max-md:!w-7 max-md:rounded-md max-md:!p-1.5 md:!h-9 md:!w-9 md:rounded-lg md:!p-2"
    >
      <span *ngIf="isBookmark; then favourite; else unfavourite"></span>
      <ng-template #favourite>
        <img class="!h-5 !w-5" src="assets/images/common-icon/bookmark-close.svg" alt="" />
      </ng-template>
      <ng-template #unfavourite>
        <img class="!h-5 !w-5" src="assets/images/common-icon/bookmark-open.svg" alt="" />
      </ng-template>
    </div>
  </div>
  <div
    class="flex flex-col max-md:!mt-2 md:!ml-4 md:!w-2/3 md:min-w-[calc(66.66%-16px)] md:max-w-[calc(66.66%-16px)]"
  >
    <div class="flex flex-row justify-between">
      <!-- <div class="max-md:!w-[80%] max-md:!h-9 2xl:!w-[65%] xl:max-2xl:!w-[50%] md:max-xl:!w-[50%] md:!h-12"></div> -->
      <div class="max-md:!w-[80%]">
        <div
          (mouseenter)="showStarTooltip = true"
          (mouseleave)="showStarTooltip = false"
          class="relative"
        >
          <app-star
            [count]="item.star"
            starStyle="!gap-0.5"
            iconStyle="sctr-icon-solid-star-01 text-palette-amber-400 text-xl"
          >
          </app-star>
        </div>
        <div>
          <a
            [routerLink]="[detailLink()]"
            [queryParams]="detailParams(item.id)"
            [replaceUrl]="true"
            target="_self"
            #hotelName
            (mouseover)="mouseOverHotelName()"
            class="truncate font-inter !font-semibold text-palette-gray-900 max-md:!text-base md:!text-xl"
            (click)="viewDetail()"
            pTooltip="{{ carTitle }}"
            tooltipStyleClass="tooltipCustom"
          >
            {{ carTitle }}
          </a>
          <span
            *ngIf="
              item.location?.district?.name ||
              item.location?.province?.name ||
              item.location?.country?.name
            "
            class="line-clamp-1 text-[14px] text-gray-600"
          >
            {{ item.location?.district?.name ? item.location?.district?.name + ', ' : ''
            }}{{ item.location?.province?.name ? item.location?.province?.name + ', ' : ''
            }}{{ item.location?.country?.name ? item.location?.country?.name + ', ' : '' }}
          </span>
          <span
            *ngIf="
              !item.location?.district?.name &&
              !item.location?.province?.name &&
              !item.location?.country?.name
            "
            class="line-clamp-1 text-[14px] text-gray-600"
          >
            {{ 'car_owner.car_has_no_address' | translate }}
          </span>
          <div
            class="tooltip-hotel-name z-100 absolute inline-block whitespace-nowrap rounded-lg bg-white !px-3 py-2 text-center text-xs font-semibold text-palette-gray-700 transition-opacity duration-200 ease-in"
          >
            {{ item.vehicle_info?.car_model_name }}
          </div>
        </div>
      </div>
      <div>
        <div class="flex w-fit items-center justify-end">
          <div class="flex flex-col items-end gap-1" *ngIf="item.sum_review">
            <p
              class="mb-[2px] flex w-[40px] items-center justify-center rounded-md border border-palette-blue-700 text-right font-inter !font-medium text-palette-blue-700 md:!text-base"
            >
              {{ item.point }}
            </p>
            <p class="whitespace-nowrap font-inter !font-normal text-palette-gray-500 md:!text-sm">
              {{ 'pluralization.total_reviews' | translate : { count: item.sum_review } }}
            </p>
            <!-- <div *ngIf="!isVote" class="w-full ">
                            <p class="md:!text-base font-inter !font-medium text-right text-palette-gray-700">{{item.sum_review}}</p>
                            <p class="md:!text-sm font-inter !font-normal text-palette-gray-500">{{ item.sum_review }} reviews</p>
                        </div> -->
            <!-- <app-rating-score [rating]="item.sum_review"
                            [style]="'max-md:absolute max-md:top-0 max-md:right-0 md:!ml-4 relative max-md:!px-2 max-md:!py-1 max-md:!text-xs max-md:!leading-[18px] md:!px-3 md:!py-1 md:!text-base md:!h-8 border border-palette-blue-600 text-palette-blue-600'"
                            [tooltipStyle]="'bottom-1/2 right-[120%] translate-y-[50%] w-[150px] min-[370px]:w-[180px]'">
                        </app-rating-score> -->
          </div>
          <div class="flex justify-center" *ngIf="!item.sum_review">
            <p class="whitespace-nowrap font-inter !text-sm !font-medium text-palette-gray-500">
              {{ 'COMMON.NEW_ON_SOCTRIP' | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="flex justify-between max-md:!h-[auto] md:!mb-2 md:!mt-3">
      <div class="relative flex flex-col max-md:!w-[90%] md:!w-[80%]">
        <div class="max-md:!w-[80%] md:!w-auto max-md:!py-2 flex relative align-middle">
            <i class="sctr-icon-marker-pin-01 !text-lg !leading-[18px] text-palette-gray-500"></i>
            <div #hotelAddress (mouseover)="mouseOverHotelAddress()" (click)="viewMap(item)"
                class="max-md:!text-xs md:!text-sm font-inter !font-medium text-palette-gray-500 !ml-1 truncate cursor-pointer">
                {{ item.location.district.name }}</div>
            <div
                class="absolute inline-block !px-3 !py-2 text-xs font-semibold text-center transition-opacity duration-200 ease-in bg-white rounded-lg tooltip-hotel-address z-100 text-palette-gray-700 whitespace-nowrap">
                {{ item.location.province.name }}</div>

        </div>
        <div class="flex align-middle">
          <p *ngIf="item.distance_from_center"
              class="max-md:!text-xs md:!text-sm font-inter !font-medium text-palette-gray-500 w-[18px] text-center">
              &nbsp;•&nbsp;</p>
          <div *ngIf="item.distance_from_center" #hotelDistance (mouseover)="mouseOverHotelDistance()"
              class="max-md:!text-xs md:!text-sm font-inter !font-medium text-palette-gray-500 !ml-1 truncate">
              {{ item.distance_from_center }} km from centre</div>
          <div
              class="absolute inline-block !px-3 !py-2 text-xs font-semibold text-center transition-opacity duration-200 ease-in bg-white rounded-lg tooltip-hotel-distance z-100 text-palette-gray-700 whitespace-nowrap">
              {{ item.distance_from_center }} km from centre</div>
      </div>
      </div>
      <div *ngIf="isVote" class="max-md:!w-[20%]">
        <p
          class="text-right font-inter !font-medium text-palette-gray-700 max-md:!text-xs max-md:!leading-[18px]"
        >
          {{ item.sum_review }}
        </p>
        <p
          class="text-right font-inter !font-normal text-palette-gray-500 max-md:!text-[10px] max-md:!leading-[16px]"
        >
          {{ item.sum_review }} {{ 'SEARCH_RESULT.car_list.automaliter' | translate }}
        </p>
      </div>
    </div> -->
    <!-- <div *ngIf="item.room_amenity_list.length > 0" class="max-md:flex max-md:!gap-2 max-md:!mt-1 md:!hidden">
            <ng-container  *ngFor="let facility of item.room_amenity_list.slice(0,5)">
                <div class="!h-4 !w-4">
                    <img class="w-full h-full" src="assets/images/home/icon/{{ facility }}.svg">
                </div>
            </ng-container>
        </div> -->
    <!-- <div class="max-md:!mt-3 max-md:relative max-md:!h-6 md:flex md:justify-between price-hidden">
            <div class="max-md:!hidden">
                <p class="md:!text-base font-inter !font-medium text-palette-gray-700">{{ item.room_type_name || 'One-Bedroom Apartment' }}</p>
            </div>
            <div *ngIf="isPrice && !item.best_match" class="max-md:absolute max-md:right-0">
                <div class="max-md:!text-sm max-md:!ml-0.5 md:!text-base md:!ml-0.5 line-through font-inter !font-normal !text-palette-gray-500">
                    <app-price-format [price]="item.origin_price"></app-price-format>
                </div>
            </div>grid grid-cols-3 gap-2
        </div> -->
    <div class="flex flex-1 flex-col justify-end gap-3">
      <div class="relative flex items-end justify-between">
        <div class="w-full max-w-[350px]">
          <app-car-highlight
            *ngIf="item?.is_without_driver || !isAgencyService"
            [dataDetailCar]="item"
          ></app-car-highlight>
        </div>
        <div class="bottom-0 right-0 col-span-1">
          <div
            *ngIf="rentalType === 'is_without_driver' || !isAgencyService"
            class="max-md:absolute max-md:bottom-0 max-md:right-0 md:!ml-4"
          >
            <div class="flex items-end justify-end">
              <div class="flex justify-end max-md:relative md:!h-full md:items-end">
                <div
                  class="w-max-md:!hidden font-inter !font-medium !text-palette-gray-400 line-through md:!ml-0.5 md:flex md:items-center md:!text-base md:!leading-tight"
                >
                  <app-price-format
                    [keepValue]="userCurrency === item.currency"
                    *ngIf="item.original_price > item.price"
                    [price]="
                      userCurrency === item?.currency
                        ? item.original_price_canal
                        : item.original_price
                    "
                  ></app-price-format>
                </div>
              </div>
              <div class="flex justify-end max-md:relative md:!h-full md:items-end">
                <div
                  class="!ml-0.5 flex items-center font-inter !font-bold !text-palette-orange-dark-500 max-md:!text-[24px] max-md:!leading-[30px] md:!ml-1.5 md:!text-[24px] md:!leading-none"
                >
                  <app-price-format
                    [keepValue]="userCurrency === item.currency"
                    [price]="userCurrency === item?.currency ? item?.price_canal : item?.price"
                  ></app-price-format>
                </div>
              </div>
            </div>
            <div class="flex justify-end max-md:relative md:!h-full md:items-end">
              <span
                class="text-soctrip-small ml-1 w-max overflow-hidden text-ellipsis text-[14px] font-normal text-palette-gray-500"
              >
                {{ 'SEARCH_RESULT.car_list.taxes_charges' | translate }}
              </span>
            </div>
          </div>
          <div
            *ngIf="rentalType === 'is_with_driver' && isAgencyService"
            class="max-md:absolute max-md:bottom-0 max-md:right-0 md:!ml-4"
          >
            <div class="flex w-max flex-col items-end gap-1">
              <div
                *ngIf="item?.original_price_per_distance && rentBy !== 'hour'"
                class="flex items-end gap-1"
              >
                <div class="mb-[-1px] font-inter !font-medium !text-palette-gray-400 line-through">
                  <app-price-format
                    *ngIf="item.original_price_per_distance > item.price_per_distance"
                    [price]="
                      userCurrency === item.currency
                        ? item.original_price_per_distance_canal
                        : item.original_price_per_distance
                    "
                    [keepValue]="userCurrency === item.currency"
                  ></app-price-format>
                </div>
                <div class="text-2xl font-semibold leading-none text-palette-orange-dark-600">
                  <app-price-format
                    [keepValue]="userCurrency === item.currency"
                    [price]="
                      userCurrency === item.currency
                        ? item.price_per_distance_canal
                        : item.price_per_distance
                    "
                  ></app-price-format>
                </div>
                <span class="!text-md font-normal text-palette-gray-500">/km</span>
                <!-- <span class="sctr-icon-info-circle text-sm text-palette-gray-500"></span> -->
              </div>
              <div
                *ngIf="item.original_price_per_hour && rentBy !== 'distance'"
                class="flex items-end gap-1"
              >
                <div class="mb-[-1px] font-inter !font-medium !text-palette-gray-400 line-through">
                  <app-price-format
                    *ngIf="item.original_price_per_hour > item.price_per_hour"
                    [keepValue]="userCurrency === item.currency"
                    [price]="
                      userCurrency === item.currency
                        ? item.original_price_per_hour_canal
                        : item.original_price_per_hour
                    "
                  ></app-price-format>
                </div>
                <div class="text-2xl font-semibold leading-none text-palette-orange-dark-600">
                  <app-price-format
                    [keepValue]="userCurrency === item.currency"
                    [price]="
                      userCurrency === item.currency
                        ? item.price_per_hour_canal
                        : item.price_per_hour
                    "
                  ></app-price-format>
                </div>
                <span class="!text-md font-normal text-palette-gray-500"
                  >/{{ 'SEARCH_RESULT.car_list.hour' | translate }}</span
                >
                <!-- <span class="sctr-icon-info-circle text-sm text-palette-gray-500"></span> -->
              </div>
            </div>
          </div>
          <ng-container
            *ngIf="
              item?.badge_info?.rank_info &&
              item?.badge_info?.rank_info?.reduce_amount &&
              !isWithDriverServiceType
            "
            [ngTemplateOutlet]="rankBadgeTemplate"
            [ngTemplateOutletContext]="{ $implicit: item?.badge_info?.rank_info, ctxItem: item }"
          >
          </ng-container>
          <ng-container
            *ngIf="
              badgeMappingInfo?.rank_info &&
              badgeMappingInfo?.rank_info?.reduce_amount &&
              isWithDriverServiceType
            "
            [ngTemplateOutlet]="rankBadgeWithDriverTemplate"
            [ngTemplateOutletContext]="{ $implicit: badgeMappingInfo?.rank_info }"
          >
          </ng-container>
        </div>
      </div>
      <div class="max-md:!hidden md:flex md:items-end md:justify-between">
        <div
          *ngIf="rentalType === 'is_with_driver' && isAgencyService"
          class="flex items-center gap-2 text-sm text-palette-gray-500"
        >
          <!-- <span class="sctr-icon-info-circle"></span> -->
          <img src="assets/icons/seat.svg" />
          {{ item?.seats }} {{ 'SEARCH_RESULT.car_list.seats' | translate }}
        </div>
        <div
          *ngIf="isVisibleTag"
          #policy
          class="overflow-hidden md:flex md:max-h-[3.75rem] md:w-full md:flex-wrap md:gap-y-2"
        >
          <app-tag
            *ngFor="let policy of displayPolicy"
            [type]="policy.type"
            [item]="policy.name"
          ></app-tag>
          <!-- <span #hotelPolicy (mouseover)="mouseOverHotelPolicy()" *ngIf="hasRemainingPolicy" class="md:!h-[22px] md:!py-[2px] md:!px-2 md:rounded-2xl md:!mr-2 font-inter !text-xs !font-medium !leading-[18px] bg-[#EAECF0] text-palette-gray-700">{{ remainingPolicy }}</span>
                  <div *ngIf="hotelPolicyArray" class="tooltip-hotel-policy absolute inline-block !px-3 py-2 text-xs font-semibold text-center transition-opacity duration-200 ease-in bg-white rounded-lg z-100 text-palette-gray-700 whitespace-nowrap">
                      {{ slicePolicy }}
                  </div> -->
        </div>
        <div></div>
        <div>
          <a
            [routerLink]="[detailLink()]"
            [queryParams]="detailParams(item.id)"
            [replaceUrl]="true"
            target="_self"
            class="cursor-pointer whitespace-nowrap rounded-lg bg-[#1570EF] font-inter !font-semibold text-palette-base-white md:!w-[162px] md:!px-[18px] md:!py-2.5 md:!text-base"
            (click)="viewDetail()"
          >
            {{ 'SEARCH_RESULT.car_list.view_detail' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #mobileTemp>
  <div
    class="mb-[8px] flex flex-col gap-2 rounded-lg border border-[#EAECF0] bg-white bg-opacity-5 py-[0.75rem] shadow-sm"
    (click)="viewDetail()"
  >
    <div class="t-mob-card-title flex items-center justify-between gap-2 px-[0.75rem]">
      <div class="w-full">
        <a
          [routerLink]="[detailLink()]"
          [queryParams]="detailParams(item.id)"
          [replaceUrl]="true"
          target="_self"
          #hotelName
          (mouseover)="mouseOverHotelName()"
          class="truncate font-inter text-[14px]/5 !font-semibold text-palette-gray-900"
          (click)="viewDetail()"
        >
          {{ item.vehicle_info?.car_model_name }}
        </a>
        <span class="line-clamp-1 text-[12px]/4 text-system-gray-500">
          {{ item.location?.district?.name }}, {{ item.location?.province?.name }},
          {{ item.location?.country?.name }}
        </span>
        <div
          class="tooltip-hotel-name z-100 absolute inline-block whitespace-nowrap rounded-lg bg-white !px-3 py-2 text-center text-xs font-semibold text-palette-gray-700 transition-opacity duration-200 ease-in"
        >
          {{ item.vehicle_info?.car_model_name }}
        </div>
      </div>
      <button
        class="t-bookmark-btn flex items-center rounded-lg border border-system-gray-300 bg-white p-1.5"
        (click)="handleBookmark($event, item.id)"
      >
        <i
          [ngClass]="
            isBookmark
              ? 'sctr-icon-solid-bookmark text-[#FDB022]'
              : 'sctr-icon-bookmark text-system-gray-500'
          "
          class="text-base/4"
        ></i>
      </button>
    </div>
    <div class="t-mob-card-body flex gap-2 px-[0.75rem]">
      <div class="relative flex aspect-[3/2] w-[132px]">
        <div
          class="absolute left-1 top-1 rounded-[4px] bg-[#10182866] px-2 py-1"
          *ngIf="item?.point"
        >
          <p class="font-inter text-sm/4 !font-medium text-white">
            {{ item.point }}
          </p>
        </div>
        <a
          [routerLink]="[detailLink()]"
          [queryParams]="detailParams(item.id)"
          [replaceUrl]="true"
          target="_self"
        >
          <img
            class="aspect-[3/2] w-[132px] min-w-[132px] cursor-pointer rounded-md border !object-cover"
            (click)="viewDetail()"
            [src]="getPropertyImageId(item)"
          />
        </a>
        <span
          *ngIf="promotion"
          class="bg-gradient-orange absolute !bottom-2 !left-2 rounded-bl-md rounded-tr-md !px-1 !py-0.5 text-center !text-sm font-semibold text-white"
          >-{{ promotion }}%</span
        >
        <ng-container
          *ngIf="
            item.badge_info &&
            item.badge_info.badge_info?.id &&
            item.badge_info.badge_info?.avatar &&
            !isWithDriverServiceType
          "
          [ngTemplateOutlet]="badgeTemplate"
          [ngTemplateOutletContext]="{ $implicit: item.badge_info.badge_info }"
        >
        </ng-container>
        <ng-container
          *ngIf="
            badgeMappingInfo &&
            badgeMappingInfo.badge_info_list &&
            badgeMappingInfo.badge_info_list.length > 0 &&
            isWithDriverServiceType
          "
        >
          <div *ngFor="let badge of badgeMappingInfo.badge_info_list">
            <ng-container
              [ngTemplateOutlet]="badgeTemplate"
              [ngTemplateOutletContext]="{ $implicit: badge }"
            >
            </ng-container>
          </div>
        </ng-container>
      </div>
      <div
        *ngIf="item?.is_with_driver && isAgencyService"
        class="flex items-start gap-2 text-sm text-palette-gray-500"
      >
        <!-- <span class="sctr-icon-info-circle"></span> -->
        <img src="assets/icons/seat.svg" />
        {{ item?.seats }} {{ 'SEARCH_RESULT.car_list.seats' | translate }}
      </div>
      <div
        *ngIf="item?.is_without_driver || !isAgencyService"
        class="flex flex-col flex-wrap gap-2"
      >
        <app-car-highlight
          [dataDetailCar]="item"
          displayUnitType="SHORT"
          class="[&_span]:text-sm/4"
        ></app-car-highlight>
        <div #policy *ngIf="displayPolicy?.length" class="flex flex-wrap gap-1">
          <app-tag
            [type]="displayPolicy[0].type"
            [item]="displayPolicy[0].name"
            class="inline-table whitespace-nowrap [&_div]:w-fit [&_div]:rounded-full [&_span]:px-1.5 [&_span]:py-0.5"
          ></app-tag>
          <div class="flex gap-2">
            <app-tag
              *ngIf="displayPolicy.length >= 2"
              [type]="displayPolicy[1].type"
              [item]="displayPolicy[1].name"
              class="inline-table whitespace-nowrap [&_div]:w-fit [&_div]:rounded-full [&_span]:px-1.5 [&_span]:py-0.5"
            ></app-tag>
            <div
              *ngIf="displayPolicy.length - 2 > 0"
              class="flex rounded-full bg-[#EFF8FF] px-[8px] py-[2px]"
              pTooltip="{{ 'SEARCH_RESULT.car_list.view_detail' | translate }}"
              (click)="viewDetail()"
            >
              <span class="text-sm font-normal text-branding-primary-600">
                + {{ displayPolicy.length - 2 }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="t-mob-card-footer flex flex-col items-end justify-end gap-1 border-t border-t-system-gray-200 px-[0.75rem] pt-[0.5rem]"
    >
      <ng-container
        *ngIf="
          item?.badge_info?.rank_info &&
          item?.badge_info?.rank_info?.reduce_amount &&
          !isWithDriverServiceType
        "
        [ngTemplateOutlet]="rankBadgeTemplate"
        [ngTemplateOutletContext]="{ $implicit: item?.badge_info?.rank_info, ctxItem: item }"
      >
      </ng-container>
      <ng-container
        *ngIf="
          badgeMappingInfo?.rank_info &&
          badgeMappingInfo?.rank_info?.reduce_amount &&
          isWithDriverServiceType
        "
        [ngTemplateOutlet]="rankBadgeWithDriverTemplate"
        [ngTemplateOutletContext]="{ $implicit: badgeMappingInfo?.rank_info }"
      >
      </ng-container>

      <div
        *ngIf="rentalType === 'is_without_driver' || !isAgencyService"
        class="flex items-center justify-end"
      >
        <div class="flex justify-end">
          <div class="font-inter !font-medium !text-palette-gray-400 line-through">
            <app-price-format
              [keepValue]="userCurrency === item.currency"
              *ngIf="item.original_price > item.price"
              [price]="
                userCurrency === item?.currency ? item.original_price_canal : item.original_price
              "
              class="[&_div]:text-md"
            ></app-price-format>
          </div>
        </div>
        <div class="flex justify-end">
          <div
            class="!ml-0.5 flex items-center font-inter !font-bold !text-palette-orange-dark-500"
          >
            <app-price-format
              [keepValue]="userCurrency === item.currency"
              [price]="userCurrency === item?.currency ? item?.price_canal : item?.price"
              class="[&_div]:text-xl"
            ></app-price-format>
          </div>
        </div>
      </div>
      <div
        *ngIf="rentalType === 'is_with_driver' && isAgencyService"
        class="flex w-full justify-end"
      >
        <div class="flex w-max flex-col items-end gap-1">
          <div
            *ngIf="item?.original_price_per_distance && rentBy !== 'hour'"
            class="flex items-end gap-1"
          >
            <div
              class="mb-[-2px] font-inter text-md !font-medium !text-palette-gray-400 line-through"
            >
              <app-price-format
                *ngIf="item.original_price_per_distance > item.price_per_distance"
                [price]="
                  userCurrency === item.currency
                    ? item.original_price_per_distance_canal
                    : item.original_price_per_distance
                "
                [keepValue]="userCurrency === item.currency"
              ></app-price-format>
            </div>
            <div class="text-base font-semibold leading-none text-palette-orange-dark-600">
              <app-price-format
                [keepValue]="userCurrency === item.currency"
                [price]="
                  userCurrency === item.currency
                    ? item.price_per_distance_canal
                    : item.price_per_distance
                "
              ></app-price-format>
            </div>
            <span class="!text-sm font-normal text-palette-gray-500">/km</span>
            <!-- <span class="sctr-icon-info-circle text-sm text-palette-gray-500"></span> -->
          </div>
          <div
            *ngIf="item?.original_price_per_hour && rentBy !== 'distance'"
            class="flex items-end gap-1"
          >
            <div
              class="mb-[-2px] font-inter text-md !font-medium !text-palette-gray-400 line-through"
            >
              <app-price-format
                *ngIf="item.original_price_per_hour > item.price_per_hour"
                [keepValue]="userCurrency === item.currency"
                [price]="
                  userCurrency === item.currency
                    ? item.original_price_per_hour_canal
                    : item.original_price_per_hour
                "
              ></app-price-format>
            </div>
            <div class="text-base font-semibold leading-none text-palette-orange-dark-600">
              <app-price-format
                [keepValue]="userCurrency === item.currency"
                [price]="
                  userCurrency === item.currency ? item.price_per_hour_canal : item.price_per_hour
                "
              ></app-price-format>
            </div>
            <span class="!text-sm font-normal text-palette-gray-500"
              >/{{ 'SEARCH_RESULT.car_list.hour' | translate }}</span
            >
            <!-- <span class="sctr-icon-info-circle text-sm text-palette-gray-500"></span> -->
          </div>
        </div>
      </div>
      <div *ngIf="item?.is_without_driver || !isAgencyService" class="flex justify-end">
        <span
          class="text-soctrip-small ml-1 w-max overflow-hidden text-ellipsis text-[12px] font-normal text-palette-gray-500"
        >
          {{ 'SEARCH_RESULT.car_list.taxes_charges' | translate }}
        </span>
      </div>
    </div>
  </div>
</ng-template>
<app-toast></app-toast>
<app-dialog-save-list-car
  [visible]="visible"
  [detailId]="item.id"
  (disable)="closeDialog()"
></app-dialog-save-list-car>
<!-- rank template  -->
<ng-template #rankBadgeTemplate let-rankInfo let-ctxItem="ctxItem">
  <div
    class="mb-1 mt-1 flex flex-row items-center rounded-[2px] px-[3px] py-1"
    style="background: linear-gradient(90.93deg, #eaecf0 0%, #eaecf0 69.02%, #eaecf0 98.59%)"
    (click)="goToRankPage(rankInfo?.refer_link ?? '', $event)"
    pTooltip="{{ rankInfo?.name ?? '' }}"
  >
    <img
      class="aspect-square h-5 !w-5 object-cover"
      [src]="(rankInfo?.avatar | ImagePath : 'thumbnail') ?? ''"
    />
    <div class="flex flex-row items-center gap-[3px] pl-[2px] pr-1">
      <span class="whitespace-nowrap whitespace-nowrap text-xs font-normal text-gray-700">
        {{ 'common.term.discount_more' | translate }}
      </span>
      <span class="text-sm font-semibold text-gray-900">
        <app-price-format
          [keepValue]="userCurrency === ctxItem?.currency"
          [price]="
            badgeInfoService.getReduceAmountPrice(
              rankInfo?.reduce_amount,
              rankInfo?.reduce_amount / ctxItem?.price,
              userCurrency,
              ctxItem?.currency || 'USD',
              ctxItem?.price || 0,
              ctxItem?.price_canal || 0
            )
          "
          [justifyContentClass]="'justify-start'"
        ></app-price-format>
      </span>
    </div>
  </div>
</ng-template>

<ng-template #rankBadgeWithDriverTemplate let-rankInfo>
  <div
    class="mb-1 mt-1 flex flex-row items-center gap-2 rounded-[2px] px-[3px] py-1"
    style="background: linear-gradient(90.93deg, #eaecf0 0%, #eaecf0 69.02%, #eaecf0 98.59%)"
    (click)="goToRankPage(rankInfo?.refer_link ?? '', $event)"
    pTooltip="{{ rankInfo?.name ?? '' }}"
  >
    <img
      class="aspect-square !h-6 !w-6 object-cover"
      [src]="(rankInfo?.avatar | ImagePath : 'thumbnail') ?? ''"
    />
    <div class="flex flex-row items-center gap-[3px] pl-[2px] pr-1">
      <span class="whitespace-nowrap text-xs font-normal text-gray-700">{{
        'common.term.discount_more' | translate
      }}</span>
      <span class="text-sm font-semibold text-gray-900">
        <app-price-format
          [keepValue]="userCurrency === item?.currency"
          [price]="rankInfo?.reduce_amount"
          [justifyContentClass]="'justify-start'"
        ></app-price-format>
      </span>
    </div>
  </div>
</ng-template>

<!-- badge template  -->
<ng-template #badgeTemplate let-badgeInfo>
  <div class="absolute !left-2 !top-2 rounded-[4px] bg-[#10182866] p-1">
    <img
      *ngIf="badgeInfo?.id && badgeInfo.avatar"
      class="aspect-square h-[24px] rounded-[4px] object-cover"
      [src]="(badgeInfo.avatar | ImagePath : 'thumbnail') ?? ''"
      pTooltip="{{ badgeInfo?.name ?? '' }}"
      alt="{{ badgeInfo?.name }}"
    />
  </div>
</ng-template>
